module.exports = __webpack_public_path__ + "hyperion-v2-static/fonts/TruenoExBd.88d5fca3.otf";